import { Actions, Getters, store, userSettingsStore } from '@/store';
import { computed } from 'vue';

export default {
    async guideCompleted(id: number) {
        await userSettingsStore.ProductGuideStepUpdate(id);
        const computedProductGuideSteps = computed(() => userSettingsStore.ProductGuideSteps);

        await userSettingsStore.setProductGuideSteps({
            ProductGuideSteps: computedProductGuideSteps.value
        });
    }
};
